import { render, staticRenderFns } from "./Vacuna.vue?vue&type=template&id=498e049b&"
import script from "./Vacuna.vue?vue&type=script&lang=js&"
export * from "./Vacuna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports